// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'topicskeys',
  initialState: {
    topicsKeysData: [],
    topicsKeysName:"Topics and Keywords",

    reserTopics:[]
  },
  reducers: {
    topicsKeysData: (state, action) => {
      state.topicsKeysData = action.payload
    },
    topicsKeysName: (state, action) => {
      state.topicsKeysName = action.payload
    },
    resetTopics: state => {
      state.topicsKeysData = []
      
    }
    
}
})

export const { topicsKeysData, topicsKeysName, resetTopics} = userSlice.actions

export default userSlice.reducer